import React from "react";
import ExamPanel from "./ExamPanel";

const sections = [
  { part: "1", content: "Speaking and Writing", time: "70 minutes" },
  { part: "2", content: "Reading", time: "30 minutes" },
  { part: "3", content: "Listening", time: "46 minutes" },
];

export default function FullSectionPage() {
  return (
    <ExamPanel
      eyebrow="Full mock structure"
      title="Welcome"
      instructions="The full mock is split into the same major skill areas you will see in the exam."
    >
      <div className="overflow-hidden rounded-md border border-slate-200">
        <div className="grid grid-cols-[88px,1fr,150px] bg-slate-50 px-4 py-3 text-xs font-bold uppercase tracking-wide text-gray-500 max-sm:hidden">
          <span>Part</span>
          <span>Content</span>
          <span>Time allowed</span>
        </div>
        {sections.map((section) => (
          <div
            key={section.part}
            className="grid gap-2 border-t border-slate-100 bg-white px-4 py-4 text-sm sm:grid-cols-[88px,1fr,150px]"
          >
            <div>
              <p className="text-xs font-bold uppercase text-gray-400 sm:hidden">
                Part
              </p>
              <p className="font-bold text-gray-900">{section.part}</p>
            </div>
            <div>
              <p className="text-xs font-bold uppercase text-gray-400 sm:hidden">
                Content
              </p>
              <p className="font-semibold text-gray-700">{section.content}</p>
            </div>
            <div>
              <p className="text-xs font-bold uppercase text-gray-400 sm:hidden">
                Time
              </p>
              <p className="font-semibold text-violet-700">{section.time}</p>
            </div>
          </div>
        ))}
      </div>
    </ExamPanel>
  );
}
